var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 27",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user_svg__clip0_2615_6293)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 13.476a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0-10.834a4.333 4.333 0 110 8.667 4.333 4.333 0 010-8.667zM13 15.643a9.76 9.76 0 00-9.75 9.75 1.084 1.084 0 002.167 0 7.583 7.583 0 1115.166 0 1.084 1.084 0 002.167 0 9.76 9.76 0 00-9.75-9.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user_svg__clip0_2615_6293"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(0 .476)",
    d: "M0 0h26v26H0z"
  })))));
};

export default SvgUser;